<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="480px"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">弱密码修改</v-toolbar-title>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                    label="当前密码"
                    type="password"
                    :rules="rules.oldPassword"
                    v-model="item.oldPassword"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="新密码"
                    type="password"
                    :rules="rules.password"
                    v-model="item.password"
                    persistent-hint
                    hint="包含小写字母、大写字母、数字和特殊符号, 长度大于8个字符"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="新密码确认"
                    type="password"
                    :rules="rules.rePassword"
                    v-model="item.rePassword"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import mixin from '@/mixin'
import {mapGetters} from "vuex";

const baseUri = '/api/syst/user';

export default {
  mixins: [mixin.edit(baseUri)],
  data() {
    return {
      formValid: false,

      item: {},
      freshItem: {
        "oldPassword": "",
        "password": "",
        "rePassword": "",
      },

      /**
       * 验证规则
       */
      rules: {
        oldPassword: [
          v => !!v || '必填项。',
          v => (v === this.passwordRaw) || '原密码错误。'
        ],
        password: [
          v => !!v || '必填项。',
          v => (v && v.length <= 20) || '长度必须小于20个字符。',
          v => (v && window.xutil.passwdStrength(v) === 'strong') || '密码为弱口令，密码必须包含小写字母、大写字母、数字和特殊符号，且长度不少于8个字符'
        ],
        rePassword: [
          v => !!v || '必填项。',
          v => (v && v.length <= 20) || '长度必须小于20个字符。',
          v => (v && this.item.password === v) || '两次输入的密码不一致.'
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['passwordRaw']),
  },

  methods: {
    // after save
    afterSave() {
      this.$store.commit("updatePassword", this.item.password);
    },
    afterGetData(data) {
      data.password = ''
      data.rePassword = ''
      data.oldPassword = ''
    },

    // mixin 加载数据后调用
    beforeSendData(data) {
      Object.assign(data, this.item);
    }
  }
}
</script>
